import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=06dc420a"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=06dc420a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dc420a')) {
      api.createRecord('06dc420a', component.options)
    } else {
      api.reload('06dc420a', component.options)
    }
    module.hot.accept("./UploadFile.vue?vue&type=template&id=06dc420a", function () {
      api.rerender('06dc420a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/UploadFile.vue"
export default component.exports